import React, { useEffect, useState } from 'react'
import {useSelector} from 'react-redux' 
import { Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { adminlog } from '../../../features/auth';

const ProtectedRoute = ({children}) => {
   let dispatch = useDispatch()
   const [isLoading, setIsLoading] = useState(true);
   const {adminlogedin} = useSelector((state)=>state.auth);

   useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      dispatch(adminlog(true))
    } else {
      dispatch(adminlog(false))
    }
setIsLoading(false); 
  }, [dispatch]); 

if (isLoading) {
    return <div></div>; 
  }
    if(adminlogedin === false){
       return <Navigate to='/'/>
    }
     return children
        
    
}

export default ProtectedRoute